import { ReactNode } from 'react'
import { Box, IconButton } from '@mui/material'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import Title from '~/src/components/mui-wrappers/Title'
import useAuthenticationFlowDialogs from '~/src/hooks/auth/flow/useAuthenticationFlowDialogs'

interface Props {
  children: ReactNode,
  showBackButton?: boolean,
  onBack?(): void,
}

const AuthenticationDialogTitle = (
  {
    children,
    onBack,
    showBackButton = false
  }: Props
) => {
  const { back } = useAuthenticationFlowDialogs()

  const _handleOnBack = () => {
    if (onBack) {
      onBack()
      return
    }

    back()
  }

  return (
    <Box sx={{
      display: 'inline-flex',
      gap: 1
    }}>
      {showBackButton && (
        <IconButton
          onClick={_handleOnBack}
          sx={{
            borderRadius: 'var(--btn-border-radius)',
            color: 'inherit'
          }}
        >
          <ArrowBackIosNewIcon style={{ fontSize: 20 }} />
        </IconButton>
      )}

      <Title
        variant='h3'
        sx={{
          fontSize: 'min(max(1rem, 5vw), 2rem)',
          display: 'inline-flex',
          alignItems: 'center'
        }}>
        {children}
      </Title>
    </Box>
  )
}

export default AuthenticationDialogTitle
